import { apiAuth, apiResponseType } from ".";

export const getExpenseTypesData = (page: number = 1): apiResponseType =>
  apiAuth.get(`expense-types?page=${page}`);

export const selectExpenseTypesData = (): apiResponseType =>
  apiAuth.get(`expense-types/select`);

export const searchExpenseTypesData = (params: { name: string }): apiResponseType =>
  apiAuth.get(`expense-types?name=${params.name}`);

export const storeExpenseTypeData = (data: {
  name: string;
  description: string;
  is_recurrence: boolean;
  expense_category_id: number;
}) =>
  apiAuth.post("expense-types/store", data) as apiResponseType;

export const updateExpenseTypeData = (
  uuid: string,
  data: {
    name: string;
    description: string;
    is_recurrence: boolean;
    expense_category_id: number;
  }
) =>
  apiAuth.put(`expense-types/${uuid}/update`, data) as apiResponseType;

export const deleteExpenseTypeData = (uuid: string) =>
  apiAuth.delete(`expense-types/${uuid}/destroy`) as apiResponseType;

export const toggleExpenseTypeStatus = (uuid: string) =>
  apiAuth.put(`expense-types/${uuid}/toggle-status`) as apiResponseType;

export const getShowExpenseType = (uuid: string) =>
  apiAuth.get(`expense-types/${uuid}/show`) as apiResponseType; 